import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import { Layout } from "@/components/Layout";
import { CurrencyProvider } from "@/lib/currency";
import { CartProvider } from "@/lib/cart";
import { ThemeProvider } from "@/lib/theme";

import Home from "@/pages/Home";
import ShopLanding from "@/pages/ShopLanding";
import Category from "@/pages/Category";
import BrowseIndex from "@/pages/BrowseIndex";
import Product from "@/pages/Product";
import ConsultIndex from "@/pages/ConsultIndex";
import ConsultService from "@/pages/ConsultService";
import Booking from "@/pages/Booking";
import Tools from "@/pages/Tools";
import VerifyCertificate from "@/pages/tools/VerifyCertificate";
import { RudrakshaFinder } from "@/pages/tools/Finders";
import {
  CaratRattiConverter, FreeKundli, MuhuratCalendar, NumerologyCalculator,
} from "@/pages/tools/Calculators";
import Promises from "@/pages/Promises";
import Scoreboard from "@/pages/Scoreboard";
import {
  About, Consultants, Energisation, HowWeSource, LabsWeRefuse, Verification,
} from "@/pages/AboutPages";
import {
  Account, AccountData, Cart, Checkout, OrderPage, Track,
} from "@/pages/Commerce";
import {
  Contact, Crisis, Faq, Guides, NotFound, Puja, ScopeOfPractice,
} from "@/pages/Misc";
import Legal from "@/pages/Legal";
import Customize from "@/pages/Customize";
import Search from "@/pages/Search";
import CollectionSemiPrecious from "@/pages/CollectionSemiPrecious";
import GuideRudrakshaMukhi from "@/pages/GuideRudrakshaMukhi";
import GrahaDetail from "@/pages/GrahaDetail";
import RashiDetail from "@/pages/RashiDetail";

export default function App() {
  return (
    <ThemeProvider>
      <CurrencyProvider>
        <CartProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />

                <Route path="/shop" element={<ShopLanding />} />
                <Route path="/search" element={<Search />} />
                <Route path="/collection/semi-precious" element={<CollectionSemiPrecious />} />
                <Route path="/shop/all" element={<Category />} />
                <Route path="/shop/gemstones" element={<Category />} />
                <Route path="/shop/gemstones/:stone" element={<Category />} />
                <Route path="/shop/gemstones/:stone/:carat" element={<Category />} />
                <Route path="/shop/rudraksha" element={<Category />} />
                <Route path="/shop/rudraksha/:mukhi" element={<Category />} />
                <Route path="/shop/malas" element={<Category />} />
                <Route path="/shop/bracelets" element={<Category />} />
                <Route path="/shop/pendants" element={<Category />} />
                <Route path="/shop/yantras" element={<Category />} />
                <Route path="/shop/by-planet" element={<BrowseIndex />} />
                <Route path="/shop/by-rashi" element={<BrowseIndex />} />
                <Route path="/shop/by-planet/:graha" element={<Category />} />
                <Route path="/shop/by-rashi/:sign" element={<Category />} />
                <Route path="/shop/by-intent/:intent" element={<Category />} />
                <Route path="/shop/by-budget/:tier" element={<Category />} />
                <Route path="/shop/new" element={<Category />} />
                <Route path="/shop/sold-archive" element={<Category />} />
                <Route path="/product/:slug" element={<Product />} />

                <Route path="/consult" element={<ConsultIndex />} />
                <Route path="/consult/puja" element={<Puja />} />
                <Route path="/consult/scope-of-practice" element={<ScopeOfPractice />} />
                <Route path="/consult/if-you-are-in-crisis" element={<Crisis />} />
                <Route path="/consult/book/:service" element={<Booking />} />
                <Route path="/consult/:slug" element={<ConsultService />} />

                <Route path="/tools" element={<Tools />} />
                <Route path="/tools/verify-a-certificate" element={<VerifyCertificate />} />
                <Route path="/tools/rudraksha-finder" element={<RudrakshaFinder />} />
                <Route path="/tools/carat-ratti-converter" element={<CaratRattiConverter />} />
                <Route path="/tools/numerology-calculator" element={<NumerologyCalculator />} />
                <Route path="/tools/free-kundli" element={<FreeKundli />} />
                <Route path="/tools/muhurat-calendar" element={<MuhuratCalendar />} />

                <Route path="/promises" element={<Promises />} />
                <Route path="/about" element={<About />} />
                <Route path="/about/consultants" element={<Consultants />} />
                <Route path="/about/how-we-source" element={<HowWeSource />} />
                <Route path="/about/verification" element={<Verification />} />
                <Route path="/about/labs-we-refuse" element={<LabsWeRefuse />} />
                <Route path="/about/energisation" element={<Energisation />} />
                <Route path="/about/scoreboard" element={<Scoreboard />} />

                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:id" element={<OrderPage />} />
                <Route path="/track" element={<Track />} />
                <Route path="/account" element={<Account />} />
                <Route path="/account/data" element={<AccountData />} />
                <Route path="/account/orders" element={<Navigate to="/track" replace />} />
                <Route path="/wishlist" element={<Navigate to="/account" replace />} />

                <Route path="/guide" element={<Guides />} />
                <Route path="/guide/rudraksha-mukhi" element={<GuideRudrakshaMukhi />} />
                <Route path="/guides/rudraksha-mukhi" element={<GuideRudrakshaMukhi />} />
                <Route path="/graha/:slug" element={<GrahaDetail />} />
                <Route path="/rashi/:slug" element={<RashiDetail />} />
                <Route path="/guide/*" element={<Guides />} />
                <Route path="/blog" element={<Guides />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/support/hours" element={<Contact />} />

                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/customize" element={<Customize />} />
                <Route path="/customise" element={<Navigate to="/customize" replace />} />

                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </CartProvider>
      </CurrencyProvider>
    </ThemeProvider>
  );
}
